import i18n from "i18next";
import { orderBy } from "lodash";
import { SessionAssignment, Interval } from "@models/ISchema";
import { Week } from "../context/linkData.reducer";
import { BlockRanges } from "../context/formData.reducer";
import Block from "./Block";

class AssignmentLabeler {
  static fromWeeks(intervals: Interval[], savedWeeks: Week[], linkWeeks: Week[] = []) {
    if (!savedWeeks?.length && !linkWeeks?.length && !intervals?.length) {
      return "";
    }

    if (savedWeeks) {
      return AssignmentLabeler.labelByIntervals(savedWeeks.filter(week => week.checked === true));
    }

    const intervalIds = new Set(linkWeeks.map(week => week.id));
    const weeksInCommon = (intervals ?? []).filter(interval => intervalIds.has(interval.id));

    return AssignmentLabeler.labelByIntervals(weeksInCommon);
  }

  static fromDate(assignment: SessionAssignment, blockRange: BlockRanges) {
    let assigmentSaved = "";

    if (blockRange) {
      const block = new Block(blockRange);

      if (block.day && block.startTime && block.endTime && block.selected === "hours") {
        assigmentSaved = block.blockLabel;
      }
      if (block.blocks && blockRange.selected === "blocks") {
        assigmentSaved = i18n.t(
          "assignation-edit.form.schedule.radio-options.not-required-schedule",
        );
      }
      if (assigmentSaved) return assigmentSaved;
    }

    return assignment?.blockRange
      ? i18n.t("assignation-edit.form.schedule.radio-options.not-required-schedule")
      : new Block(assignment?.blockRange as BlockRanges).blockLabel;
  }

  static labelByIntervals(intervals: Week[]) {
    if (!intervals?.length) return "";

    const sortedIntervals = orderBy(intervals, ["startingDate"], ["asc"]);
    const separation = this._weeksHaveGap(sortedIntervals) ? "---" : "-";
    const valueFirst = sortedIntervals[0]?.value;
    const valueLast = sortedIntervals[sortedIntervals.length - 1]?.value;

    if (!valueFirst && !valueLast) return "-";

    return valueFirst === valueLast
      ? `S${valueFirst}`
      : `S${valueFirst} ${separation} S${valueLast}`;
  }

  static _weeksHaveGap(weeks: Week[]) {
    const { gapFound } = weeks.reduce(
      ({ prevWeek, gapFound }, currWeek) => {
        if (!prevWeek) return { prevWeek: currWeek, gapFound: false };
        return {
          prevWeek: currWeek,
          gapFound: gapFound ? true : currWeek.value - prevWeek.value > 1,
        };
      },
      { prevWeek: null, gapFound: false },
    );
    return gapFound;
  }
}

export default AssignmentLabeler;
